















import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    watch,
    Ref,
    ref,
} from '@vue/composition-api';
import { MultiSelectOptionType, GroupSearchOption } from '../type';

export default defineComponent({
    props: {
        searchItem: {
            type: Object as PropType<GroupSearchOption>,
            required: true,
        },
        appId: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const options = computed(() => {
            const optionGroup: MultiSelectOptionType[] = [];
            props.searchItem.searchOption.split(';').forEach((item: string) => {
                if (item) {
                    const temp = (item as string).split('|');
                    optionGroup.push({
                        caption: temp[0],
                        title: temp[1],
                    });
                }
            });
            return optionGroup;
        });
        const inputVal = ref();
        function handleChange() {
            context.emit('update-single-select', {
                type: props.searchItem.searchName,
                value: inputVal.value,
            });
        }
        watch(
            () => props.appId,
            (val) => {
                if (val) {
                    inputVal.value = options.value[0].caption;
                }
            },
            { immediate: true },
        );

        return {
            inputVal,
            options,
            handleChange,
        };
    },
});
